import React from 'react'
import {
withSitecoreContext,
Image
} from '@sitecore-jss/sitecore-jss-react'
import './index.scss'
import Slider from "react-slick";
import useMediaQuery from '../../lib/custom-hooks/useMediaQuery';

const SplitGallery = (props) => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const isExpEditorEnabled = props?.sitecoreContext?.pageEditing;
    const SampleNextArrow = (props) => {
        if (isExpEditorEnabled == false) {
            const { className, style, onClick } = props;
            return (
            <div className={className} style={{ ...style }} onClick={onClick}></div>
            );
        } else {
            return <div></div>;
        }
    };
    const SamplePrevArrow = (props) => {
        if (isExpEditorEnabled == false) {
            const { className, style, onClick } = props;
            return (
            <div className={className} style={{ ...style }} onClick={onClick}></div>
            );
        } else {
            return <div></div>;
        }
    };
    const downloadImage = (href: string) => {

    }
    const settings = {
      arrows: true,
      dots: true,
      swipe: true,
      dotsClass: "dots-button",
      slidesToScroll: 1,
      slidesToShow: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      infinite: true,
      autoplay: false,
    };

    return (
        <section className={"split-gallery"}>
            <Slider {...settings}>
                {props?.fields?.List?.map((item, index) => (
                    <div className="split-gallery-slide">
                        <a className="slick-arrow arrow-download" href={isMobile ? (item?.fields?.ImageMobile ? item?.fields?.ImageMobile?.value?.src : item?.fields?.Image?.value?.src) : item?.fields?.Image?.value?.src} download>
                            <div className="arrow-download-wrapper">
                            </div>
                        </a>
                        <Image field={isMobile ? (item?.fields?.ImageMobile ? item?.fields?.ImageMobile : item?.fields?.Image) :item?.fields?.Image} />
                        {item?.fields?.Caption?.value && item?.fields?.Caption?.value != '' ?
                            <p className="split-gallery-caption">{item?.fields?.Caption?.value}</p>
                            :
                            <></>
                        }
                    </div>
                ))}
            </Slider>
        </section>
    );
};

export default withSitecoreContext()(SplitGallery)
  